// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","cart":"cart-3C4HH"};